import React, { useEffect, useRef, useState } from 'react'
import Card from 'react-bootstrap/Card'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Spinner from 'react-bootstrap/Spinner'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { useFormik } from 'formik'
import { useDispatch, useSelector } from 'react-redux'
import { Modal } from 'react-bootstrap'
import { Auth } from 'recupero-comunes'
import { cargarArchivoFormSchema } from '../../common/validation-Schemas-carga-emision-pago-cia'
import { getInfoCargaAnalyticPrevio } from '../../store/actions/carga-casos-analytic-action'
import { cargarArchivoAction } from '../../store/actions/carga-casos-analytic-action'

const CargarArchivo = () => {
  const { rutUsuario, rutOrganizacion, paisOrganizacion } = Auth.currentUser()
  const user = {
    rutUsrCreacion: rutUsuario,
    idOrganizacion: rutOrganizacion,
    modulo: 'dcpa',
    codPais: paisOrganizacion
  }
  const [show, setShow] = useState(false)
  const fileRef = useRef()
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch()
  const dataCargaMasiva = useSelector(
    (state) => state.cargaEmisionPagosCIAReducer
  )
  const { archivo } = dataCargaMasiva

  const handleShow = () => setShow(true)
  const handleClose = () => {
    dispatch(getInfoCargaAnalyticPrevio())
    setTimeout(async () => {dispatch(getInfoCargaAnalyticPrevio());}, 4000);
    setShow(false)
  }

  useEffect(() => {
    dispatch(getInfoCargaAnalyticPrevio())
  }, [dispatch])

  const formik = useFormik({
    initialValues: {
      file: null      
    },
    validationSchema: cargarArchivoFormSchema,
    onSubmit: (values) => {
      setLoading(true)
      getBase64(values.file)
        .then((base64data) => {
          let data = {
            ...user,
            filename: values.file.name,
            mimetype: values.file.type,
            base64data: base64data            
          }          
          dispatch(cargarArchivoAction(data))
            .then(() => {
              handleReset()
              dispatch(getInfoCargaAnalyticPrevio())
              handleShow()              
            })
            .catch((error) => {
              setLoading(false)
              console.error('fallo la carga ',error.message)              
            })
        })
        .catch((error) => {
          setLoading(false)          
          console.error(error.message)          
        })
    }
  })

  const handleReset = () => {
    fileRef.current.value = ''
    formik.resetForm()
    setLoading(false)
  }

  return (
    <div>
      <Modal show={show} onHide={handleClose} backdrop='static'>
        <Modal.Header closeButton>
          <Modal.Title>Respuesta de la información enviada</Modal.Title>
        </Modal.Header>
        <Modal.Body>{archivo ? archivo : 'Enviando...'}</Modal.Body>
        {archivo && (
          <Modal.Footer>
            <Button variant='primary' onClick={handleClose}>
              Aceptar
            </Button>
          </Modal.Footer>
        )}
      </Modal>
      
      

      <Card.Header
        className='text-center'
        style={{ backgroundColor: '#4F517A', color: 'white' }}
      >
        Carga de Siniestros Proceso Analytic
      </Card.Header>

      <Form noValidate onSubmit={formik.handleSubmit} className='mt-4'>
        <Row className='align-items-center'>
          <Col md='4' className='px-4 mb-4 mt-auto'>            
          </Col>
          <Col md='8' className='px-4 mb-0 mt-auto'>
            <Form.Group className='position-relative'>
              <Form.Control
                ref={fileRef}
                type='file'
                name='file'
                onChange={(event) => {
                  formik.setFieldValue('file', event.currentTarget.files[0])
                }}
                onBlur={formik.handleBlur}
                isInvalid={!!formik.errors.file}
                isValid={formik.touched.file && !formik.errors.file}
              />
              <Form.Text className='text-muted'>
                Tamaño máximo del archivo: 10MB
              </Form.Text>
              <Form.Control.Feedback type='invalid'>
                {formik.errors.file}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Row>

        <hr className='mt-4' />

        <div className='d-grid gap-2 d-md-flex justify-content-md-end'>
          <Button
            className='me-md-2'
            variant='warning'
            type='button'
            onClick={() => {
              handleReset()
            }}
          >
            Limpiar
          </Button>
          <Button variant='danger' type='submit' disabled={loading}>
            {loading ? (
              <div>
                <Spinner
                  as='span'
                  animation='border'
                  size='sm'
                  role='status'
                  aria-hidden='true'
                />{' '}
                Cargando...
              </div>
            ) : (
              'Cargar Archivo'
            )}
          </Button>
        </div>

        <div style={{ color: '#0dcaf0' }}>
          (*) Carga de pagos emitidos a: CIA's, Indemnización a Terceros, Gastos
          & Honorarios.
        </div>
      </Form>
    </div>
  )
}

export default CargarArchivo

const getBase64 = (file) => {
  return new Promise((resolve) => {
    let reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => {
      resolve(reader.result)
    }
  })
}

